import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Sound options: 'none' | 'numbers' | 'numbers_phrases'
// Animation options: '3d' | 'simple'

const useBingoStore = create(
  persist(
    (set, get) => ({
      // Bingo configuration
      bingoName: '',
      soundOption: 'numbers_phrases', // 'none' | 'numbers' | 'numbers_phrases'
      animationOption: '3d', // '3d' | 'simple'
      isConfigured: false, // Whether bingo has been configured and started

      // Game state
      numbers: generateBingoNumbers(),
      drawnNumbers: [],
      drawnNumber: null, // Keeps track of the most recently drawn number
      from: 1, 
      to: 75, 

      // Configure and start a new bingo
      configureBingo: (config) => {
        set({
          bingoName: config.bingoName || 'Bingo',
          soundOption: config.soundOption || 'numbers_phrases',
          animationOption: config.animationOption || '3d',
          isConfigured: true,
          numbers: generateBingoNumbers(1, 75),
          drawnNumbers: [],
          drawnNumber: null,
        });
      },

      // End the current bingo and return to config screen
      finalizeBingo: () => {
        set({
          bingoName: '',
          soundOption: 'numbers_phrases',
          animationOption: '3d',
          isConfigured: false,
          numbers: generateBingoNumbers(1, 75),
          drawnNumbers: [],
          drawnNumber: null,
        });
      },

      // Step 1: Draw a number from the list (but don't save it yet)
      drawNumber: () => {
        const availableNumbers = get().numbers;
        if (availableNumbers.length === 0) return; // No numbers left to draw

        // Get a random index and draw the number
        const index = Math.floor(Math.random() * availableNumbers.length);
        const drawnNumber = availableNumbers[index];

        // Remove the drawn number from the numbers list and update the drawnNumber state
        set((state) => ({
          numbers: state.numbers.filter((_, i) => i !== index),
          drawnNumber, // Save the drawn number to be manually added later
        }));
      },

      // Step 2: Save the drawn number to drawnNumbers manually
      saveNumber: () => {
        const drawnNumber = get().drawnNumber;
        if (drawnNumber === null) return; // No number to save

        // Add the drawn number to drawnNumbers and reset the drawnNumber state
        set((state) => ({
          drawnNumbers: [...state.drawnNumbers, drawnNumber],
        }));
      },

      // Reset the game to the initial state (keeps configuration)
      resetGame: () => {
        set({
          numbers: generateBingoNumbers(1, 75),
          drawnNumbers: [],
          drawnNumber: null,
        });
      },

      // Update configuration options during game
      updateConfig: (config) => {
        set({
          ...(config.bingoName !== undefined && { bingoName: config.bingoName }),
          ...(config.soundOption !== undefined && { soundOption: config.soundOption }),
          ...(config.animationOption !== undefined && { animationOption: config.animationOption }),
        });
      },
    }),
    {
      name: 'bingo-game', // name of the item in localStorage
    }
  )
);

// Generate a list of numbers from a given range
function generateBingoNumbers(from = 1, to = 75) {
  const numbers = [];
  for (let i = from; i <= to; i++) {
    numbers.push(i);
  }
  return numbers;
}

export default useBingoStore;
